'use strict';

class ComponentEvent {
	static get UPDATE_STATE() { return 'updateState' };
	static get RESET() { return 'reset' };

	constructor(){
	}
}